import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import css from './IconShield.module.css';

const IconShield = props => {
  const { rootClassName, className } = props;
  const classes = clsx(rootClassName || css.root, className);
  return (
    <svg 
      className={classes}
      xmlns="http://www.w3.org/2000/svg" 
      width="18" 
      height="18" 
      preserveAspectRatio="xMidYMid meet" 
      viewBox="0 0 24 24">
      <rect x="0" y="0" width="24" height="24" fill="none" stroke="none" />
      <g fill="none">
        <path d="M13.147 21.197l1.67-1.168a13.393 13.393 0 0 0 5.447-13.624a.837.837 0 0 0-.453-.586L12 2L4.19 5.819a.837.837 0 0 0-.454.586a13.393 13.393 0 0 0 5.448 13.624l1.67 1.168a2 2 0 0 0 2.293 0z" stroke="#4e4b66" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>
  );
};

IconShield.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

IconShield.propTypes = {
  rootClassName: string,
  className: string,
};

export default IconShield;
